var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 195,
    viewBox: "0 0 97 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 8,
    fill: "#43BBC9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 97,
    height: 8,
    fill: "#209BB7",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 97,
    height: 187,
    fill: "#209BB7",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5114 85.4858L50.5114 108.923L46.5341 108.923L46.5341 85.4858L50.5114 85.4858ZM60.2415 95.2159L60.2415 99.1932L36.804 99.1932L36.804 95.2159L60.2415 95.2159Z",
    fill: "#43BBC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup56);
export default __webpack_public_path__ + "static/media/Group56.1b3875838b7c9764a2f44effd61847f3.svg";
export { ForwardRef as ReactComponent };